import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import useAppView from 'Core/Hooks/useAppView'
import { SearchInput } from 'V2Components'
import { Button, SelectDropDown, ToggleViewControl, Typography } from 'procyon-ui'
import React from 'react'

function Header({
  searchKey,
  setSearchKey,
  onAddApplicationClick,
  selectedTag,
  setSelectedTag,
  tags = []
}) {
  const { appView } = useAppView()

  return (
    <div>
      <div className='flex justify-between items-center'>
        <div className=''>
          <SelectDropDown
            showHelpText={false}
            width='307px'
            onChange={(e) => setSelectedTag(e.target.value)}
            menuItems={[
              {
                label: 'All',
                value: ''
              },
              {
                label: <em>Without Tags</em>,
                value: '-'
              },
              ...tags
            ]}
            value={selectedTag}
          />
        </div>
        <div className='flex gap-6'>
          <SearchInput className='!w-[303px]' searchKey={searchKey} onChange={setSearchKey} />
          <ToggleViewControl
            ariaLabel='view control'
            options={['grid', 'table']}
            value={['grid']}
          />
        </div>
      </div>
    </div>
  )
}

export { Header }
